import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getBookTopicsByBookCode } from "../../../actions";
import { Link } from "react-router";

const BookTopicList = ({ bookCode }) => {
  const [loading, setLoading] = useState(true);
  const [topics, setTopics] = useState([]);
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language?.toLowerCase().substring(0, 2);

  useEffect(() => {
    loadData();
  }, []);

  function loadData() {
    getBookTopicsByBookCode(bookCode)
      .then((data) => {
        setTopics(data);
        setLoading(false);
      })
      .catch((e) => setLoading(false));
  }

  if (loading || topics.length < 1) return null;
  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap gap-2">
        {topics.map((t) => {
          return (
            <Link
              key={t.id}
              to={`/literature?sortby=creationdate&language=${currentLanguage}&topicId=${t.id}&serieId=0&reload=true`}
              className="btn btn-outline-secondary btn-sm"
              style={{ borderRadius: "20px", padding: "0.4rem 1rem", fontWeight: "600" }}
            >
              {t.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BookTopicList;
